{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversations selected",
    "AGENT_SELECT_LABEL": "Välj agent",
    "ASSIGN_CONFIRMATION_LABEL": "Are you sure to assign {conversationCount} {conversationLabel} to",
    "UNASSIGN_CONFIRMATION_LABEL": "Are you sure to unassign {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Go back",
    "ASSIGN_LABEL": "Tilldela",
    "YES": "Ja",
    "SEARCH_INPUT_PLACEHOLDER": "Sök",
    "ASSIGN_AGENT_TOOLTIP": "Tilldela agent",
    "ASSIGN_TEAM_TOOLTIP": "Tilldela team",
    "ASSIGN_SUCCESFUL": "Conversations assigned successfully.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Conversations resolved successfully.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Conversations visible on this page are only selected.",
    "AGENT_LIST_LOADING": "Laddar agenter",
    "UPDATE": {
      "CHANGE_STATUS": "Change status",
      "SNOOZE_UNTIL": "Snooza",
      "UPDATE_SUCCESFUL": "Conversation status updated successfully.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "No labels found for",
      "ASSIGN_SELECTED_LABELS": "Assign selected labels",
      "ASSIGN_SUCCESFUL": "Labels assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Välj team",
      "NONE": "Inget",
      "NO_TEAMS_AVAILABLE": "There are no teams added to this account yet.",
      "ASSIGN_SELECTED_TEAMS": "Assign selected team.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Slå samman konversationer",
      "TITLE": "Slå samman konversationer",
      "DESCRIPTION": "Välj en målkonversation. Alla andra valda konversationer slås samman med den — deras meddelanden flyttas till målkonversationen och källkonversationerna tas bort.",
      "TARGET_LABEL": "Målkonversation (behålls)",
      "SOURCES_LABEL": "Källkonversationer (tas bort)",
      "SELECT_TARGET": "Välj en konversation som mål för sammanslagningen",
      "WARNING": "Varning: Denna åtgärd kan inte ångras. Meddelanden från alla källkonversationer flyttas till målkonversationen och källkonversationerna raderas permanent.",
      "SUBMIT": "Slå samman konversationer",
      "CANCEL": "Avbryt",
      "SUCCESS_MESSAGE": "Konversationerna har slagits samman",
      "ERROR_MESSAGE": "Det gick inte att slå samman konversationerna. Försök igen.",
      "CONFIRM": {
        "TITLE": "Bekräfta sammanslagning",
        "DESCRIPTION": "Är du säker på att du vill slå samman {sourceCount} konversationer med #{targetId}? Denna åtgärd kan inte ångras.",
        "YES": "Ja, slå samman",
        "CANCEL": "Avbryt"
      }
    }
  }
}
